import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import CheckboxField from 'components/application/CheckboxField';

export default function Estimates({ estimates, onChange }) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'trainingRegisterReports.components.Estimates',
  });

  return (
    <>
      <label className='tw-mb-3 tw-font-medium'>{i18nT('label')}</label>
      <div>
        <CheckboxField
          checked={estimates.costAndTime}
          label={i18nT('costAndTime.label')}
          name='estimates_cost_and_time'
          onChange={(event) => onChange('costAndTime', event.target.checked)}
          value='estimates_cost_and_time'
        />
      </div>
    </>
  );
}

Estimates.propTypes = {
  estimates: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};
